export default {
  REQUEST_TIMEOUT: 30000,

  UNKNOWN_ERR_MSG: 'An unexpected error occurred. Please try again.',
  INVALID_FIELDS: 'Required fields are invalid or missing.',
  REQUIRED_FIELD: 'Required',
  INVALID_FORMAT: 'Invalid Format',
};
